import { render, staticRenderFns } from "./NotificationListTable.vue?vue&type=template&id=6d695832&scoped=true&"
import script from "./NotificationListTable.vue?vue&type=script&lang=js&"
export * from "./NotificationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d695832",
  null
  
)

export default component.exports